import { useState } from "react";

const useModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalDescription, setModalDescription] = useState("");
    const [modalContent, setModalContent] = useState<React.ReactNode>(null);

    const openModal = (
        title: string,
        description: string,
        content: React.ReactNode
    ) => {
        setModalTitle(title);
        setModalDescription(description);
        setModalContent(content);
        setIsOpen(true);
    };

    const closeModal = () => setIsOpen(false);

    return {
        isOpen,
        modalTitle,
        modalDescription,
        modalContent,
        openModal,
        closeModal,
    };
};

export default useModal;
